<template>
    <div>
        <ConformityCheckListHeaderButton ref="conformityButton" @click="toggleCheckList" />
        <CompassPopover
            class="conformity-popover"
            :isVisible="isVisible"
            triggerRef="conformityButton"
            placement="bottom"
            @close="isVisible = false"
        >
            <div class="conformity-popover__wrapper">
                <h3 class="conformity-popover__title typographies-heading-h3">
                    {{ checkListTitle }}
                </h3>
                <div class="conformity-popover__introduction typographies-paragraph-medium-regular">
                    <img :src="checkListIllustration" :alt="checkListTitle" width="60" />
                    <p>
                        {{ checkListDescription }}
                    </p>
                </div>
                <template v-if="!companyInformationLocked">
                    <CompassCallout class="conformity-popover__callout" :items="calloutItems" />
                    <CompassButton
                        class="conformity-popover__button"
                        :label="$t.__('eInvoicing.conformityCheckListHeader.button.label')"
                        leftIcon="shield-check"
                        @click="goToSettings"
                    />
                </template>
                <template v-else>
                    <CheckList
                        class="conformity-popover__checklist"
                        :items="checkListItems"
                        :loading="isLoading"
                    />
                    <CompassLink
                        class="conformity-popover__link"
                        data-bot="checklist-FE_button--FAQ"
                        :label="$t.__('eInvoicing.conformityCheckListHeader.link.label')"
                        size="small"
                        link="https://help.sellsy.com/fr/collections/14117844-facturation-electronique"
                        target="_blank"
                    />
                </template>
            </div>
        </CompassPopover>
    </div>
</template>
<script>
import ConformityCheckListHeaderButton from 'vcomponents/eInvoicing/ConformityCheckListHeader/ConformityCheckListHeaderButton.vue';
import CheckList from 'vcomponents/common/CheckList/CheckList.vue';
import { getEInvoicingStatus } from 'api/mandate';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: corpMapGetters } = createNamespacedHelpers('corp');
import { goToUrl } from 'vueDir/helpers.js';

export default {
    components: {
        ConformityCheckListHeaderButton,
        CheckList,
    },
    data() {
        return {
            isVisible: false,
            isLoading: false,
            checkListItems: [
                {
                    id: 'pdp_mandates',
                    label: this.$t.__('eInvoicing.conformityCheckListHeader.pdp_mandates.label'),
                    dataBot: 'checklist-FE_button--Mandat-PA',
                },
                {
                    id: 'account_parameters',
                    label: this.$t.__(
                        'eInvoicing.conformityCheckListHeader.account_parameters.label',
                    ),
                    dataBot: 'checklist-FE_button--Update-Parameters',
                },
                {
                    id: 'customers_directory',
                    label: this.$t.__(
                        'eInvoicing.conformityCheckListHeader.customers_directory.label',
                    ),
                    dataBot: 'checklist-FE_button--Update-Directory',
                },
            ],
            calloutItems: [
                this.$t.__('eInvoicing.conformityCheckListHeader.callout.item_1'),
                this.$t.__('eInvoicing.conformityCheckListHeader.callout.item_2'),
                this.$t.__('eInvoicing.conformityCheckListHeader.callout.item_3'),
            ],
        };
    },
    computed: {
        ...corpMapGetters({
            companyInformationLocked: 'getCompanyInformationLocked',
        }),
        checkListTitle() {
            return !this.companyInformationLocked
                ? this.$t.__('eInvoicing.conformityCheckListHeader.title_alt')
                : this.$t.__('eInvoicing.conformityCheckListHeader.title');
        },
        checkListDescription() {
            return !this.companyInformationLocked
                ? this.$t.__('eInvoicing.conformityCheckListHeader.description_alt')
                : this.$t.__('eInvoicing.conformityCheckListHeader.description');
        },
        checkListIllustration() {
            return !this.companyInformationLocked
                ? '/ressources/logged/img/illustrations/pdp/user-identity.svg'
                : '/ressources/logged/img/illustrations/invoicing-signature-blue.svg';
        },
    },
    methods: {
        toggleCheckList() {
            this.isVisible = !this.isVisible;

            if (this.companyInformationLocked && this.isVisible) {
                this.isLoading = true;
                getEInvoicingStatus()
                    .then((response) => {
                        this.checkListItems = this.checkListItems
                            .filter((item) => !!response.data[item.id])
                            .map((item) => {
                                const itemInfo = response.data[item.id];
                                return {
                                    ...item,
                                    ...itemInfo,
                                };
                            });
                    })
                    .catch(() => {
                        this.checkListItems = [];
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
        goToSettings() {
            goToUrl('/settings/company-information');
        },
    },
};
</script>
<style lang="scss" scoped>
.conformity-popover {
    &__wrapper {
        display: flex;
        flex-direction: column;
        padding: var(--spacing-1);
    }

    &__title {
        margin: 0 0 var(--spacing-1);
    }

    &__introduction {
        color: var(--colors-common-text-subtle-default);
        display: flex;
        gap: var(--spacing-2);
        margin-bottom: var(--spacing-4);

        p {
            margin: 0;
        }
    }

    &__checklist {
        margin-bottom: var(--spacing-4);
    }

    &:deep(.compass-popover__content) {
        width: 400px;
    }

    &__link {
        align-self: flex-start;
    }

    &__callout {
        margin-bottom: var(--spacing-4);
    }

    &__button {
        align-self: flex-end;
    }
}
</style>
